/**
 * Split text so hyphenated words ("AI-konsulent") can be kept on one line.
 * Shared by the React H1 and the prerendered static HTML.
 */
export function splitHyphenWords(text: string): Array<{ text: string; nowrap: boolean }> {
  return text
    .split(/(\S+-\S+)/)
    .filter(part => part.length > 0)
    .map(part => ({ text: part, nowrap: /\S-\S/.test(part) }))
}

export function noWrapHyphensHtml(text: string, escape: (s: string) => string): string {
  return splitHyphenWords(text)
    .map(p => (p.nowrap ? `<span class="whitespace-nowrap">${escape(p.text)}</span>` : escape(p.text)))
    .join('')
}
